import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, Transition as _Transition, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/photo.png';
import _imports_1 from '@/assets/images/realize.png';
import _imports_2 from '@/assets/images/artalk-img.png';
const _withScopeId = n => (_pushScopeId("data-v-2939b331"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  name: "referrer",
  content: "no-referrer"
}, null, -1));
const _hoisted_2 = {
  class: "illustrate"
};
const _hoisted_3 = {
  id: "panel",
  style: {
    "display": "flex",
    "align-items": "center",
    "margin": "0 auto"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "upload-img",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_5 = {
  style: {
    "display": "flex",
    "justify-content": "center"
  }
};
const _hoisted_6 = {
  class: "tip"
};
const _hoisted_7 = {
  target: "_blank",
  href: "https://www.sciencedirect.com/science/article/pii/S1566253523001203"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "realize",
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_9 = {
  class: "main-content"
};
const _hoisted_10 = {
  class: "introduce-list"
};
const _hoisted_11 = {
  class: "introduce-item"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "img-and-detail"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
})], -1));
const _hoisted_13 = {
  class: "info rightTextShow"
};
const _hoisted_14 = {
  class: "title"
};
const _hoisted_15 = {
  class: "titleSecond"
};
const _hoisted_16 = {
  class: "titleThird"
};
const _hoisted_17 = {
  style: {
    "text-align": "right"
  }
};
import { ref } from "vue";
import "element-plus/es/components/message/style/css";
import i18n from "@/language/index";
import CustomDialog from "./components/CustomDialog.vue";
import axios from "axios";
export default {
  __name: 'Index',
  setup(__props) {
    // import Header from "@/components/Header";
    // import PageFooter from "@/components/PageFooter";
    const isRetrieval = ref(true);
    // const backgroundColor = ref("");
    const uploadInputUrl = ref(); // 输入的图片url
    const isStartUpload = ref(false); // 是否已点击解析按钮
    const dialogRef = ref(null);
    const uploadPopover = ref();
    const uploadRef = ref();
    const uploadImage = event => {
      dialogRef.value.showDialog().then(() => {
        dialogRef.value.handleUpload(event);
      });
    };
    const uploadChange = uploadFile => {
      dialogRef.value.showDialog().then(() => {
        const files = [uploadFile.raw];
        const target = {
          files
        };
        const event = {
          target
        };
        dialogRef.value.handleUpload(event);
      });
    };
    const triggerPopover = () => {
      document.getElementById('hidden__button').click();
    };
    const generateFromURL = event => {
      if (uploadInputUrl.value) {
        axios.get(uploadInputUrl.value, {
          responseType: 'blob'
        }).then(res => {
          dialogRef.value.showDialog().then(() => {
            const files = [new window.File([res.data], res.config.url.split("/").pop(), {
              type: res.data.type
            })];
            const target = {
              files
            };
            const event = {
              target
            };
            dialogRef.value.handleUpload(event);
          });
        });
      }
    };
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_popover = _resolveComponent("el-popover");
      return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _withDirectives(_createElementVNode("div", null, [_createElementVNode("div", {
        class: _normalizeClass(["upload-bg", {
          small: isStartUpload.value
        }])
      }, [_withDirectives(_createElementVNode("h2", null, _toDisplayString(_ctx.$t("home.culturalImgDescRight1")), 513), [[_vShow, !isStartUpload.value]]), _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("artalkText.explain")), 1), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_input, {
        class: _normalizeClass(["reference-button", _unref(i18n).global.locale.value === 'en' ? 'inputWidth' : '']),
        size: "large",
        modelValue: uploadInputUrl.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => uploadInputUrl.value = $event),
        placeholder: _ctx.$t('artalkText.placeholderUrl')
      }, {
        suffix: _withCtx(() => [_createVNode(_component_el_icon, {
          class: "el-input__icon",
          onClick: triggerPopover
        })]),
        _: 1
      }, 8, ["modelValue", "placeholder", "class"]), _createVNode(_component_el_button, {
        onClick: generateFromURL,
        size: "large",
        class: _normalizeClass(_unref(i18n).global.locale.value === 'en' ? 'buttonWidth' : '')
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("artalkText.generating")), 1)]),
        _: 1
      }, 8, ["class"]), _createVNode(_component_el_popover, {
        ref_key: "uploadPopover",
        ref: uploadPopover,
        "popper-class": "uploadPopper",
        placement: "bottom-end",
        width: "3.44rem",
        "show-arrow": false,
        trigger: "click"
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_button, {
          id: "hidden__button",
          style: {
            "width": "0px",
            "margin": "0px",
            "border": "0px"
          },
          class: _normalizeClass(_unref(i18n).global.locale.value === 'en' ? 'buttonWidth' : '')
        }, null, 8, ["class"])]),
        default: _withCtx(() => [_createVNode(_component_el_upload, {
          ref_key: "uploadRef",
          ref: uploadRef,
          class: "upload-box",
          drag: "",
          action: "",
          "show-file-list": false,
          limit: 1,
          name: "file",
          accept: "image/*",
          "on-change": uploadChange,
          "auto-upload": false
        }, {
          default: _withCtx(() => [_hoisted_4, _createElementVNode("div", {
            class: "el-upload__text",
            onClick: _cache[1] || (_cache[1] = $event => _ctx.$refs.fileInput.click())
          }, _toDisplayString(_ctx.$t("artalkText.drag")), 1)]),
          _: 1
        }, 512), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
          class: "upload-button",
          onClick: _cache[2] || (_cache[2] = $event => _ctx.$refs.fileInput.click()),
          style: {
            "text-decoration": "none",
            "color": "white"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("artalkText.localUpload")), 1)]),
          _: 1
        })])]),
        _: 1
      }, 512)]), _createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.$t("artalkText.usage")), 513), [[_vShow, !isStartUpload.value]]), _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.$t("artalkText.accessPaper")), 1)]), _hoisted_8], 2), _createElementVNode("div", _hoisted_9, [_withDirectives(_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_Transition, {
        appear: "",
        mode: "out-in",
        name: "animate__animated animate__bounce",
        "enter-active-class": "animate__animated animate__InLeft",
        "leave-active-class": "animate__animated animate__fadeOut"
      }, {
        default: _withCtx(() => [_hoisted_12]),
        _: 1
      }), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", null, [_createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("home.culturalImgDescRight1")), 1), _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("home.culturalImgDescRight2")), 1), _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("home.culturalImgDescRight3")), 1)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("a", {
        href: "javascript:void(0)",
        onClick: _cache[3] || (_cache[3] = $event => _ctx.$refs.fileInput.click())
      }, _toDisplayString(_ctx.$t("protection.tryNow")), 1)])])])], 512), [[_vShow, !isStartUpload.value]])])], 512), [[_vShow, isRetrieval.value]]), _createVNode(CustomDialog, {
        ref_key: "dialogRef",
        ref: dialogRef
      }, null, 512), _createElementVNode("input", {
        type: "file",
        accept: "image/jpeg",
        id: "file-input",
        ref: "fileInput",
        onChange: uploadImage,
        style: {
          "display": "none"
        }
      }, null, 544)], 64);
    };
  }
};